// extracted by mini-css-extract-plugin
export default {"featList":"styles_featList__gQH8v","unavailableCallout":"styles_unavailableCallout__w6jxZ"};